import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { armoryService } from '../../services/central-api/armory';
import { View } from 'react-native';
import MyAppText from '../MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';


interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    required: boolean;
    labelFontSize?: number;
    disabled?: boolean;
    armoryShiftId: number;
}

function InChargeArmourerDropdown({ value, setValue, zIndex, required, armoryShiftId, labelFontSize = 16, disabled = false }: Props) {
    const { styles } = useStyles(styleSheet);

    const [selectableUsers, setSelectableUsers] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    async function getUsers() {
        try {
            setIsLoading(true);
            const users = await armoryService.getAssistantArmourers({ armoryShiftId });
            setSelectableUsers([
                ...users.map((user) => {
                    return {
                        value: user.id,
                        label: `${user.warName ? user.warName : user.name} - RF: ${user.registry}`
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(true);
        }
    }

    useEffect(() => {
        getUsers();
    }, [armoryShiftId]);

    return (
        <View style={{ gap: 10 }}>
            {!selectableUsers.length && !isLoading && <MyAppText style={styles.contentText}>{translate('NotFoundAssistantArmourer')}</MyAppText>}
            <FilterDropdown
                label={translate('newInChargeArmourer')}
                items={selectableUsers}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                required={required}
                labelFontSize={labelFontSize}
                disabled={disabled}
            />
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    contentText: {
        fontSize: 14,
        color: theme.colors.warnings['300'],
    }
}));


export default InChargeArmourerDropdown;
